module.exports = __webpack_public_path__ + "static/media/fast-secure.dfdec5f8.svg";